import Axios, { AxiosPromise } from 'axios'
import { MfaPreparationData } from '@fe/common/api/models/MfaPreparationData'
import { PassswordResetRequest } from '@fe/common/api/models/PassswordResetRequest'
import { PassswordChangeRequest } from '@fe/common/api/models/RequestModels/PassswordChangeRequest'
import { PreparePasswordResetMfaRequest } from '@fe/common/api/models/RequestModels/PreparePasswordResetMfaRequest'
import { User } from '@fe/common/api/models/User'
import { RequestConfig } from '@fe/common/axiosConfig'

export class PasswordApi {
  static requestResetLink(
    email: string,
    config?: RequestConfig
  ): AxiosPromise<null> {
    return Axios({
      ...config,
      url: `/users/password/recovery`,
      method: 'POST',
      data: { email },
    })
  }

  static prepareMfa(
    requestData: PreparePasswordResetMfaRequest,
    config?: RequestConfig
  ): AxiosPromise<MfaPreparationData> {
    return Axios({
      ...config,
      url: `/users/password/prepare-mfa`,
      method: 'POST',
      data: requestData,
    })
  }

  static resetPassword(
    requestData: PassswordResetRequest,
    config?: RequestConfig
  ): AxiosPromise<User> {
    return Axios({
      ...config,
      url: `/users/password/reset`,
      method: 'POST',
      data: requestData,
    })
  }

  static changePassword(
    requestData: PassswordChangeRequest,
    config?: RequestConfig
  ): AxiosPromise<User> {
    return Axios({
      ...config,
      url: `/users/password`,
      method: 'PUT',
      data: requestData,
    })
  }
}
